<template>
  <div class="payment-container">
    <vue-element-loading
      :active="loading"
      is-full-screen
    />

    <a-row
      :class="['payment-wrapper', { 'mobile': isMobile }]"
    >
      <a-col
        :xs="24"
        :sm="24"
        :md="6"
        :lg="6"
        class="steps-column"
      >
        <payment-steps
          :current="current"
          :steps="steps"
          :is-mobile="isMobile"
        />

        <div
          v-if="paymentStepHeader"
          class="step-header-alert"
        >
          <a-alert type="info" class="info-alert">
            <div
              slot="message"
              class="payment-step-text"
              v-html="paymentStepHeader"
            />
          </a-alert>
        </div>

        <div
          v-if="showSubcheoBanner"
          class="fixed-banner"
        >
          <subcheo-banner />
        </div>

      </a-col>
      <a-col
        :xs="24"
        :sm="24"
        :md="18"
        :lg="18"
        class="content-column"
      >
        <div class="steps-action">
          <a-button
            v-if="current > 0 && current < steps.length - 1"
            class="action-btn"
            @click="prev"
          >
            {{ $t("PREVIOUS_STEP") }}
          </a-button>
          <a-button
            v-if="current < steps.length - 2"
            type="primary"
            class="action-btn action-btn-primary"
            @click="next"
          >
            {{ $t("NEXT_STEP") }}
          </a-button>
          <a-button
            v-if="current == steps.length - 2"
            type="primary"
            class="action-btn btn-success"
            @click="confirmPayment"
          >
            {{ $t("FINISH_STEP") }}
          </a-button>
        </div>

        <div class="steps-content">
          <payment-header-notify
            :header-notify="headerNotify"
            @open-notify="openNotify"
            @open-popup-ok="openPopupOk"
            @open-popup-cancel="openPopupCancel"
          />

          <!-- Step Service-->
          <service-step
            v-if="steps && steps[current] && steps[current].id === 'service'"
            :payment-username="paymentUsername"
            :trigger-username="triggerUsername"
            :active-service="activeService"
            :payment-service-id="paymentServiceId"
            :option="option"
            :currency="currency"
            @username-change="handleUsernameChange"
            @service-tab-change="handleServiceTabChange"
            @service-change="handleServiceChange"
            @service-click="handleServiceClick"
          />

          <!-- Step Method-->
          <method-step
            v-if="steps && steps[current] && steps[current].id === 'method'"
            :payment-method-id="paymentMethodId"
            :option="option"
            @method-change="handleMethodChange"
            @method-click="handleMethodClick"
          />

          <!-- Step Payment-->
          <payment-step
            v-if="steps && steps[current] && steps[current].id === 'payment'"
            :payment-qr-code="paymentQrCode"
            :payment="payment"
            :payment-method-text="paymentMethodText"
            :payment-method-id="paymentMethodId"
            :payment-total="paymentTotal"
            :payment-note="paymentNote"
            :payment-pre-note="paymentPreNote"
            @copy="handleCopy"
            @confirm-payment="confirmPayment"
          />

          <!-- Step Finish-->
          <finish-step
            v-if="steps && steps[current] && steps[current].id === 'finish'"
            :payment="payment"
            :payment-success="paymentSuccess"
          />
        </div>
      </a-col>
    </a-row>

    <payment-modals
      :payment-process="paymentProcess"
      :confirm-box="confirmBox"
      :payment-total="paymentTotal"
      :payment-method-name="paymentMethodName"
      :payment="payment"
      :payment-note="paymentNote"
      :payment-finish="paymentFinish"
      :payment-contact="paymentContact"
      @close-process="handleCloseProcess"
      @confirm-ok="processConfirmPayment"
      @confirm-cancel="handleConfirmCancel"
    />
    <promo-popup />
  </div>
</template>

<script>
import mixins from './mixins';
import SubcheoBanner from '../components/SubcheoBanner.vue';
import PaymentSteps from '../components/PaymentSteps.vue';
import PaymentHeaderNotify from '../components/PaymentHeaderNotify.vue';
import ServiceStep from '../components/ServiceStep.vue';
import MethodStep from '../components/MethodStep.vue';
import PaymentStep from '../components/PaymentStep.vue';
import FinishStep from '../components/FinishStep.vue';
import PaymentModals from '../components/PaymentModals.vue';
import PromoPopup from '../components/PromoPopup.vue';

export default {
  name: 'PaymentIndex',
  mixins: [mixins],
  components: {
    'subcheo-banner': SubcheoBanner,
    'payment-steps': PaymentSteps,
    'payment-header-notify': PaymentHeaderNotify,
    'service-step': ServiceStep,
    'method-step': MethodStep,
    'payment-step': PaymentStep,
    'finish-step': FinishStep,
    'payment-modals': PaymentModals,
    'promo-popup': PromoPopup,
  },
  computed: {
    showSubcheoBanner() {
      return this.activeService && this.activeService.includes('subcheo') && !this.isMobile;
    },
  },
  methods: {
    handleUsernameChange(value) {
      this.paymentUsername = value;
      this.onChangeUsername();
    },
    handleServiceTabChange(key) {
      this.activeService = key;
    },
    handleServiceChange(value) {
      this.paymentServiceId = value;
    },
    handleServiceClick(item) {
      this.onChangeService(item);
    },
    handleMethodChange(value) {
      this.paymentMethodId = value;
    },
    handleMethodClick(item) {
      this.onChangeMethod(item);
    },
    handleCopy(content) {
      this.copyToClipboard(content);
    },
    handleCloseProcess() {
      this.$store.commit('payment/SET_PAYMENT_PROCESS', { show: false });
    },
    handleConfirmCancel() {
      this.$store.commit('payment/SET_CONFIRM_BOX', false);
    },
  },
};
</script>

<style scoped>
.payment-container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: var(--spacing-lg) var(--spacing-md);
}

.payment-wrapper {
  width: 100%;
  margin: 0 auto;
}

.payment-wrapper.mobile {
  padding: 0;
}

.steps-column {
  padding: 0;
  margin-bottom: var(--spacing-lg);
}

@media (min-width: 768px) {
  .steps-column {
    padding-right: var(--spacing-lg);
    margin-bottom: 0;
  }
}

.step-header-alert {
  margin-bottom: var(--spacing-md);
}

.info-alert {
  border-radius: var(--border-radius-md);
}

.payment-step-text {
  font-size: var(--font-size-sm);
  line-height: var(--line-height-relaxed);
  color: var(--text-secondary);
}

.payment-step-text b {
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.content-column {
  padding: 0;
}

@media (min-width: 768px) {
  .content-column {
    padding-left: var(--spacing-lg);
  }
}

.steps-action {
  display: flex;
  justify-content: flex-end;
  gap: var(--spacing-xs);
  margin-bottom: var(--spacing-md);
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .steps-action {
    justify-content: center;
  }
}

.action-btn {
  min-width: 120px;
  height: 44px;
  border-radius: var(--border-radius-md);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-base);
  transition: background-color var(--transition-base), border-color var(--transition-base), color var(--transition-base);
  touch-action: manipulation;
}

@media (max-width: 768px) {
  .action-btn {
    min-width: 90px;
    height: 44px;
    font-size: var(--font-size-base);
    padding: 0 var(--spacing-md);
  }
}

.btn-success {
  background-color: var(--success-color) !important;
  border-color: var(--success-color) !important;
}

.btn-success:hover {
  background-color: var(--success-hover) !important;
  border-color: var(--success-hover) !important;
}

.steps-content {
  margin-top: var(--spacing-md);
}

.hand-mouse {
  cursor: pointer;
}

/* Responsive optimizations */
@media (max-width: 768px) {
  .payment-container {
    padding: var(--spacing-sm);
  }

  .steps-action {
    text-align: center;
    margin-bottom: var(--spacing-md);
    gap: var(--spacing-sm);
  }

  .steps-content {
    margin-top: var(--spacing-sm);
  }
}

@media (max-width: 480px) {
  .payment-container {
    padding: var(--spacing-xs);
  }

  .steps-action {
    flex-direction: column;
    width: 100%;
  }

  .action-btn {
    width: 100%;
    min-width: 100%;
  }
}

/* Fixed banner */
.fixed-banner {
  position: sticky;
  top: 80px;
  margin-top: var(--spacing-md);
}
</style>
